import { useEffect, useRef, type ReactNode } from 'react';
import { motion } from 'motion/react';

interface ListaEntradaProps<T> {
  itens: T[];
  children: (item: T, indice: number) => ReactNode;
  chave: (item: T, indice: number) => string | number;
  className?: string;
  /** Quantos itens animam (padrão 8). */
  limite?: number;
}

// Itens entram com fade + 8 px para cima, 30 ms entre um e outro.
// Só na PRIMEIRA carga, só os 8 primeiros e nunca em listas grandes (> 20).
export default function ListaEntrada<T>({
  itens,
  children,
  chave,
  className = '',
  limite = 8,
}: ListaEntradaProps<T>) {
  const jaAnimou = useRef(false);
  const animar = !jaAnimou.current && itens.length > 0 && itens.length <= 20;

  useEffect(() => {
    if (itens.length > 0) jaAnimou.current = true;
  }, [itens.length]);

  return (
    <div className={className}>
      {itens.map((item, i) => {
        const animado = animar && i < limite;
        if (!animado) {
          return <div key={chave(item, i)}>{children(item, i)}</div>;
        }
        return (
          <motion.div
            key={chave(item, i)}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut', delay: i * 0.03 }}
          >
            {children(item, i)}
          </motion.div>
        );
      })}
    </div>
  );
}